import React from "react";
import { StyleProp, ViewStyle, StyleSheet } from "react-native";

import { TouchableBox } from "../AHTheme/Box";
import { AHIcon } from "../AHIcon";

const styles = StyleSheet.create({
  circleButton: {
    width: 50,
    height: 50,

    alignItems: "center",
    justifyContent: "center",
    borderWidth: 1,
  },
});

type AHNumberInputButtonProps = {
  disabled: boolean;
  onPress: () => void;
  type: "decrement" | "increment";
  style?: StyleProp<ViewStyle>;
};

export function AHNumberInputButton({
  disabled,
  onPress,
  type,
  style,
}: AHNumberInputButtonProps) {
  return (
    <TouchableBox
      cornerRadius="medium"
      hitSlop={
        disabled
          ? undefined
          : type === "decrement"
            ? { left: 100, right: 35, top: 10, bottom: 20 }
            : { left: 35, right: 100, top: 10, bottom: 20 }
      }
      disabled={disabled}
      onPress={onPress}
      color="background"
      borderColor="border-primary"
      style={[styles.circleButton, { opacity: disabled ? 0 : 1 }, style]}
    >
      <AHIcon
        type={type === "decrement" ? "minus" : "add"}
        color="text-secondary"
        size="small"
      />
    </TouchableBox>
  );
}
